import axios from "axios";
import checkSdc from "./helpers/checkSdc";
import DeviceDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/DeviceDetectionMixin";

const NO_SDC_ERROR = 8018;

export default {
  mixins: [DeviceDetectionMixin],
  data() {
    return {
      swaProfile: null,
      myGamesUser: null,
      showPopupInstallGame: false,
      showPopupPlatforms: false,
    };
  },
  computed: {
    checkMyGamesUserUrl() {
      const apiUrl = location.host.includes("dev-my")
        ? "https://api.dev-my.games/social/profile/v2/session"
        : "https://api.my.games/social/profile/v2/session";

      return apiUrl;
    },
    getMyGamesUser() {
      return this.myGamesUser;
    },
    isMyGamesUserRegistered() {
      return !!this.getMyGamesUser?.profile;
    },
    eventKey() {
      return `button_click_${process.env.VUE_APP_PROMO}`;
    },
    lsKey() {
      return `storage_${process.env.VUE_APP_PROMO}`;
    },
    isUserInProjectReg() {
      return !!this.swaProfile?.client_profile_fields?.reg_ts;
    },
  },
  mounted() {
    // if event is registered
    if (this.$eventBroker.getEvent(this.eventKey)) {
      // trigger button click when event has been triggered
      this.$eventBroker.subscribeToEvent(this.eventKey).then(() => {
        this.regAndDownloadClick(true);
      });
    }
  },
  created() {
    this.initUser();
  },
  methods: {
    initUser() {
      const coolAxios = axios.create();
      coolAxios.defaults.headers.common = {};

      coolAxios
        .get(this.checkMyGamesUserUrl, {
          withCredentials: true,
        })
        .then((response) => {
          const data = response.data;
          let GEMS = window.__GEMS || {};

          if (data.code) {
            //check sdc -> repeat request
            if (data.code === NO_SDC_ERROR) {
              return checkSdc(this.checkMyGamesUserUrl).then(() => this.initUser());
            }
          }

          this.myGamesUser = data;
          this.getSwaProfileInfo();

          GEMS = {
            ...GEMS,
            token: data.token,
            onProjectRegister: (resp) => {
              this.gameDownloadWrapper();
              if (resp.status === 200 || resp.status === 446) {
                this.gameDownloadWrapper();
              } else {
                console.warn("Project register error", resp);
              }
            },
          };

          window.__GEMS = GEMS;

          if (window.eventBroker && !!data.profile) {
            window.eventBroker.triggerEventQueue("after_reg");
          }
        })
        .catch((error) => {
          const code = error.code || error.status || 0;
          const data = error.data || {};
          console.error("SERVER ERROR! PANIC MODE!", code, " - ", error.status, " - ", data);
        });
    },
    async getSwaProfileInfo() {
      const responce = await window.api.userService.getSwaUserData().run();
      this.swaProfile = responce.data.result;
    },
    regAndDownloadClick(autoclick = false) {
      const download_method = autoclick ? "checkStorageAndDownload" : "gameDownloadWrapper";

      if (this.isMyGamesUserRegistered && this.isUserInProjectReg) {
        this[download_method]();
      } else {
        if (!this.isUserInProjectReg && this.isMyGamesUserRegistered) {
          if (!!window.__GEM) {
            window.__GEM.showProjectRegister();
          } else {
            document.addEventListener("GEM_loaded", () => {
              window.__GEM.showProjectRegister();
            });
          }
        } else {
          this.$eventBroker.registerEvent({
            key: this.eventKey,
            type: "after_reg",
          });
          window.__GEM.showSignup();
        }
      }
    },
    checkStorageAndDownload() {
      if (!localStorage.getItem(this.lsKey)) {
        if (!!window.__GEM) {
          this.gameDownloadWrapper();
        } else {
          document.addEventListener("GEM_loaded", () => {
            this.gameDownloadWrapper();
          });
        }
        localStorage.setItem(this.lsKey, true);
      }
    },
    gameDownloadWrapper() {
      if (this.isWindowsOs) {
        window.__GEM.detectAndDownload();
        this.showPopupInstallGame = true;
      } else {
        this.showPopupPlatforms = true;
      }
    },
  },
};
